import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { CheckboxField } from '@finam/web-ui-kit';
import styled from 'styled-components';
export var ShrinkedCheckboxField = styled(CheckboxField)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n\n  & > span:first-child {\n    height: 18px;\n    width: 18px;\n\n    margin-left: 5px;\n    margin-right: 15px;\n  }\n"])));
export default ShrinkedCheckboxField;